// extracted by mini-css-extract-plugin
module.exports = {"salaryGraph":"SalaryGraph_salaryGraph__2BSlv","salaryMarkerWrapper":"SalaryGraph_salaryMarkerWrapper__2Y0Iy"};